module.exports = __webpack_public_path__ + "img/2.d5f7a44f.jpg";